export default __webpack_public_path__ + "static/media/institut-francais.58205c3d.jpg";